import { render } from "./CompanySkill.vue?vue&type=template&id=94056470&scoped=true&ts=true"
import script from "./CompanySkill.vue?vue&type=script&lang=ts"
export * from "./CompanySkill.vue?vue&type=script&lang=ts"

import "./CompanySkill.vue?vue&type=style&index=0&id=94056470&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94056470"]])

export default __exports__